export default "__VITE_ASSET__BCvD9gSC__"